import { Context, Plugin } from '@nuxt/types';
import sleep from '../lib/utilities/sleep';

const intercom: Plugin = (context: Context, inject) => {
  inject('intercom', {
    signOut: () => {
      signOut(context);
    },
    syncUser: () => {
      syncUser(context);
    },
    openChat: message => {
      openChat(context, message);
    },
    bootUser: async () => {
      await bootUser(context);
    }
  });
};

function signOut(context: Context) {
  context.app.$gtm.push({ event: 'signOut' });
}

function syncUser(context: Context) {
  const userState = context.store.getters['user/user'];

  const user = {
    email: userState.email,
    userId: userState.id
  };

  context.app.$gtm.push({
    // if userId is not found sync user will create a new user
    // ensure frontend and backend use the same userId when creating and syncing user
    event: 'syncUser',
    user
  });
}
function openChat(context: Context, message: string) {
  context.app.$gtm.push({ event: 'openIntercomChat', message });
}

/* https://www.intercom.com/help/en/articles/170-integrate-intercom-in-a-single-page-app */
async function bootUser(context: Context) {
  const userState = context.store.getters['user/user'];

  const user = {
    email: userState.email,
    userId: userState.id
  };

  await sleep(3000);
  context.app.$gtm.push({
    event: 'bootUser',
    user
  });
}

export default intercom;
